import { Component, OnInit } from '@angular/core';
import { TutorialTypes } from '../../constants';


@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss']
})
export class TutorialComponent implements OnInit {
  menu = [];
  hasType: boolean;
  constructor() { }

  ngOnInit() {
    this.loadMenu();
  }

  loadMenu() {
    this.menu.push(TutorialTypes.VIDEOS_TUTORIALS);
    this.menu.push(TutorialTypes.DEVICE_MANUALS);
  }

  changeTab(event) {
    this.hasType = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tutorial/tutorial.component.ts